import React, { FC } from 'react';
import { ReactComponent as AiSvg } from 'assets/ai.svg';
import TooltipPoratal from 'components/UI/TooltipPoratal';
import InfoBlock from 'components/UI/InfoBlock';
import { useTranslation } from 'react-i18next';
import css from '../styles.module.scss';

interface IConversionIconProps {
  conversionActionTooltipShow: boolean;
  setConversionActionTooltipShow: React.Dispatch<React.SetStateAction<boolean>>;
  isDisabled: boolean;
  onMouseDown?: React.MouseEventHandler<SVGSVGElement>;
}

const ConversionIcon: FC<IConversionIconProps> = ({
  conversionActionTooltipShow,
  setConversionActionTooltipShow,
  isDisabled = false,
  onMouseDown,
}) => {
  const { t } = useTranslation();

  return (
    <TooltipPoratal
      right={!conversionActionTooltipShow}
      white={!conversionActionTooltipShow}
      hintWidth={365}
      showConstantly
      classname={css.conversion__tooltip}
      hintClassName={!conversionActionTooltipShow ? css.conversion__hint : ''}
      hint={
        conversionActionTooltipShow ? (
          t(`convert`)
        ) : (
          <InfoBlock color="WHITE" text={t(`conversion_link`)} />
        )
      }
      isDisabled={isDisabled}
    >
      <AiSvg
        className={css.conversion__icon}
        onMouseLeave={() => setConversionActionTooltipShow(false)}
        onMouseEnter={() => setConversionActionTooltipShow(true)}
        onMouseDown={onMouseDown}
      />
    </TooltipPoratal>
  );
};

export default ConversionIcon;
